import { createConfig } from '@0xsequence/connect';

const projectAccessKey =
  import.meta.env.VITE_SEQUENCE_PROJECT_ACCESS_KEY ||
  'AQAAAAAAAKqbF7tvWjYTHAGtpi9kiQjXZdI';
const waasConfigKey =
  import.meta.env.VITE_SEQUENCE_WAAS_CONFIG_KEY ||
  'eyJwcm9qZWN0SWQiOjQzNjc1LCJycGNTZXJ2ZXIiOiJodHRwczovL3dhYXMuc2VxdWVuY2UuYXBwIn0=';
const googleClientId =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  '588828680748-00l9uole90evj38vfbcemiuoidf6e452.apps.googleusercontent.com';

// Force the connect dialog to appear centered on mobile (not as a bottom sheet).
// The design-system Modal intentionally uses `bottom-0 rounded-b-none` for mobile.
// We target the specific combination used only by the modal (not the ToastViewport)
// and override it via the Shadow DOM's customCSS injection.
const customCSS = `
  @media (max-width: 767px) {
    .bottom-0.w-screen {
      bottom: auto !important;
    }
    .rounded-t-2xl.rounded-b-none {
      border-bottom-left-radius: 1rem !important;
      border-bottom-right-radius: 1rem !important;
    }
  }
`;

// Sequence Connect WaaS config
// Only Embedded Wallet options (email, Google) - External wallets disabled
export const sequenceConnectConfig = createConfig('waas', {
  projectAccessKey,
  waasConfigKey,
  defaultTheme: 'dark',
  position: 'center',
  customCSS,
  signIn: {
    projectName: 'Espotz',
  },
  appName: 'Espotz',
  chainIds: [137], // Polygon Mainnet
  defaultChainId: 137,
  guest: false,
  email: true,
  google: {
    clientId: googleClientId,
  },
  // Disable external wallet connectors
  coinbase: false,
  metaMask: false,
  walletConnect: false,
  // Hide external connect options (MetaMask, Coinbase, etc.)
  hideExternalConnectOptions: true,
  // Disable injected provider discovery in wagmi to prevent MetaMask auto-detection
  wagmiConfig: {
    multiInjectedProviderDiscovery: false,
  },
});

export const wagmiConfig = sequenceConnectConfig.wagmiConfig;

export default sequenceConnectConfig;
